import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { NitroButton } from 'nitro-components';

const Container = styled.div`
  width: 400px !important;
  margin: 40px auto;
  padding-bottom: 200px;

  display: flex;
  flex-direction: column;
`;

const TitleInput = styled.input`
  font-size: 30px;
  border: 0;
  outline: 0;
  background: none;
  padding-bottom: 20px;
  border-bottom: 1px solid ${props => props.theme.color.base3};
  color: ${props => props.theme.color.secondary};

  text-align: center;
  &:placeholder {
    color: ${props => props.theme.color.base2};
  }
`;

const Description = styled.textarea`
  margin-top: 40px;
  width: 100%;
  height: 200px;
  padding: 20px;
  border: 1px solid ${props => props.theme.color.border};
  resize: none;
`;

class Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportName: props.reportName,
      reportDescription: props.reportDescription
    };
  }

  componentDidMount() {
    this.setNavigation();
  }

  setDetails = () => {
    const { reportName, reportDescription } = this.state;
    this.props.actions.setDetails({
      reportName,
      reportDescription
    });
    this.props.navigation.goNext();
  };

  setNavigation = () => {
    const { reportName } = this.state;
    this.props.setNavigation({
      left: (
        <NitroButton
          action={this.props.navigation.goPrevious}
          labelVariant="secondary"
          label="PREVIOUS"
          size="extraSmall"
          leftIcon="arrow-left"
          leftIconVariant="secondary"
          insideIconSize={8}
        />
      ),
      middle: null,
      right: (
        <NitroButton
          disabled={reportName.length === 0}
          action={this.setDetails}
          label="NEXT"
          variant={reportName.length ? 'primary' : 'base3'}
          size="extraSmall"
          rightIcon="arrow-right"
          insideIconSize={8}
        />
      )
    });
  };

  changeName = event => {
    const value = event.target.value;
    this.setState(
      {
        reportName: value
      },
      () => this.setNavigation()
    );
  };

  changeDescription = event => {
    const value = event.target.value;
    this.setState({
      reportDescription: value
    });
  };

  render() {
    const { reportName, reportDescription } = this.state;
    return (
      <Container>
        <TitleInput placeholder="Enter report name" value={reportName} onChange={this.changeName} />
        <Description
          placeholder="Add a report reportDescription …"
          value={reportDescription}
          onChange={this.changeDescription}
        />
      </Container>
    );
  }
}

Details.propTypes = {
  reportName: PropTypes.string,
  reportDescription: PropTypes.string,
  navigation: PropTypes.object,
  setNavigation: PropTypes.func
};

export default Details;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Details/Details.js